import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, NotificationConfig } from '../../services/notification';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-modal.html',
  styleUrl: './notification-modal.scss'
})
export class NotificationModalComponent implements OnInit, OnDestroy {
  private notificationService = inject(NotificationService);
  private subscription?: Subscription;
  private autoCloseTimer?: any;

  visible = false;
  config?: NotificationConfig;

  ngOnInit(): void {
    this.subscription = this.notificationService.notification$.subscribe(config => {
      // Clear any existing timer
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = undefined;
      }

      this.config = config;
      this.visible = true;

      // Auto-dismiss toasts after 2 seconds (except confirm dialogs)
      if (config.type !== 'confirm') {
        this.autoCloseTimer = setTimeout(() => {
          this.visible = false;
          this.autoCloseTimer = undefined;
        }, 2000);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
  }

  close(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = undefined;
    }
    this.visible = false;
    if (this.config?.type === 'confirm' && this.config.onCancel) {
      this.config.onCancel();
    }
  }

  confirm(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = undefined;
    }
    if (this.config?.onConfirm) {
      this.config.onConfirm();
    }
    this.visible = false;
  }

  cancel(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = undefined;
    }
    if (this.config?.onCancel) {
      this.config.onCancel();
    }
    this.visible = false;
  }

  getIcon(): string {
    switch (this.config?.type) {
      case 'success':
        return 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z';
      case 'error':
        return 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z';
      case 'warning':
        return 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z';
      case 'info':
        return 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z';
      case 'confirm':
        return 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z';
      default:
        return '';
    }
  }
}
